import { render, staticRenderFns } from "./ChartVenta.vue?vue&type=template&id=5ebe81b4"
import script from "./ChartVenta.vue?vue&type=script&lang=js"
export * from "./ChartVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports